
import { defineComponent } from "vue";
import LInfoHome from "@/components/LAsideInfo/LInfoHome.vue";
import LLoginForm from "@/components/form/LLoginForm/LLoginForm.vue";
import LRegisterForm from "@/components/form/LRegisterForm/LRegisterForm.vue";
import { mapState } from "vuex";

export default defineComponent({
  name: "Home",
  components: { LInfoHome, LLoginForm, LRegisterForm },
  created() {
    document.title = "LinkList - Home";
  },
  computed: {
    ...mapState(["switchLogin", "isLogin"]),
  },
});
